export default function Separator() {
  return <hr className="border-neutral-200" />;
}
